import {useMemo} from 'react';

import {useThemeMode} from 'theme/ThemeModeProvider';

/**
 * Recharts рисует цвета SVG-атрибутами, где var(--token) поддерживается
 * не во всех браузерах, поэтому отдаём готовые значения по текущей теме.
 */
export const useChartColors = () => {
  const {resolved} = useThemeMode();

  return useMemo(() => {
    const isDark = resolved === 'dark';
    return {
      grid: isDark ? '#2C3040' : '#EEF0F4',
      axisLine: isDark ? '#2C3040' : '#EEF0F4',
      axisText: isDark ? '#9A99A5' : '#8A8894',
      cursor: isDark ? 'rgba(125, 155, 255, 0.10)' : 'rgba(99, 102, 241, 0.06)',
      // синий KPI слишком тёмный на тёмном фоне — осветляем
      kpiPrimary: isDark ? '#7D9BFF' : '#3152C7',
    };
  }, [resolved]);
};

export default useChartColors;
